module.exports = __webpack_public_path__ + "media/audio30.3bf3e4d2.mp3";